import Vue from "vue";
import { getRoomCamera } from "@/api/room-camera";
import Push from "push.js";

export default {
  async newCameraDialog({ commit, dispatch }, { camera }) {
    // as we dont receive the type in the base64, we add 'data:image/jpeg;base64,' to the image
    camera = `data:image/jpeg;base64,${camera}`;
    commit("NEW_CAMERA_DIALOG", { camera });
    dispatch(
      "dialog/openDialog",
      {
        title: Vue.i18n.translate("roomControl.doorbell"),
        camera: camera,
        confirmation: true,
      },
      { root: true }
    );
    Push.config({
      serviceWorker: "./service-worker.js", // Sets a custom service worker script
    });
    Push.create("ONEapp", {
      body: camera,
      icon: "./favicon.ico",
      onclick: function () {
        window.focus();
        this.close();
      },
    });
  },

  async getRoomCamera({ state, commit }) {
    commit("REQUEST_ROOM_CAMERA");
    try {
      const roomCamerasData = await getRoomCamera();
      commit("SUCCESS_REQUEST_ROOM_CAMERA", { roomcameras: roomCamerasData });
    } catch (e) {
      commit("FAILURE_REQUEST_ROOM_CAMERA");
    }
  },
};
